import script from "./Wine.vue?vue&type=script&setup=true&lang=js"
export * from "./Wine.vue?vue&type=script&setup=true&lang=js"

import "./Wine.vue?vue&type=style&index=0&id=3519105c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3519105c"]])

export default __exports__